import React from 'react';
import { graphql } from 'gatsby';
import { withLocation } from 'utils/hocs';
import { MainLayout } from '../components/UI/Layout/Main/mainLayout';
import { Component } from '../components/Contentful/component';
import { ProductPackMain } from '../components/Ecommerce/Product';
import { MicroDataHelmet } from '../components/Utils/MicroData/Utils/microDataHelmet';
import {
  formatContentfulComponentProps,
  returnLocalisedPath,
} from '../utils/globals';
import { productPackMicroData } from '../components/Utils/MicroData/ProductPack/productPackMicroData';

export default withLocation(({ data, pageContext }) => {
  const page = data?.contentfulPage;
  const { allLocalSlugs } = pageContext;

  const locale = data?.contentfulPage?.product?.node_locale.toLowerCase();
  const siteUrl = data?.site?.siteMetadata?.siteUrl;

  const {
    components,
    layout,
    popup,
    seoMetadata,
    slug,
    title,
    canonical,
    robots,
  } = page;

  const productUrl = `${siteUrl}/${
    process.env.GATSBY_ZONE
  }${returnLocalisedPath(locale, slug?.url || '')}`;
  const staticProductData = data?.contentfulProductPack;

  // SEO Micro Data
  const returnProductPackMicroData = productPackMicroData(
    productUrl,
    staticProductData,
    page
  );

  return (
    <>
      <MicroDataHelmet schemaOrgJSONLD={returnProductPackMicroData} />
      <MainLayout
        {...layout}
        page={{ seoMetadata, slug, title, canonical, robots, allLocalSlugs }}
        popup={popup}
        isProduct={true}>
        {components &&
          components.map((component) => {
            if (component.key === 'ProductMain') {
              return (
                <ProductPackMain
                  product={staticProductData}
                  {...formatContentfulComponentProps(component)}
                />
              );
            }
            return <Component {...component} />;
          })}
      </MainLayout>
    </>
  );
});

export const pageQuery = graphql`
  query ProductPackPageById($id: String!, $productId: String!) {
    site {
      siteMetadata {
        siteUrl
      }
    }
    contentfulProductPack(id: { eq: $productId }) {
      ...ProductPackData
      recommendations {
        ...GridData
      }
    }
    contentfulPage(id: { eq: $id }) {
      ...PageData
    }
  }
`;
